import React, { useState, Suspense, lazy, useEffect, useRef } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import Menu from '../components/Menu/Menu';
import { AuthByToken, SideBar } from '../components';
import { requestUserInfo } from '../redux/slices/app';
import docCookies from '../common/cookie';
import { requestMerchants } from '../redux/slices/merchants';
import { receivedMerchant } from '../redux/slices/merchant';
import { requestOrderStats } from '../redux/slices/orders';
import { requestCategories } from '../redux/slices/categories';
import { requestProducts } from '../redux/slices/products';
import { useDispatch, useSelector } from 'react-redux';
import { requestMerchantCategories } from '../redux/slices/merchantCategories';
import augmentProgress from '../utils/augmentProgress';
import AndroidSmartBanner from '../components/androidSmartBanner';
import { useLocation } from 'react-router';
import { LazyAnalytics, LazyBilling, LazyCustomDomain, LazyCustomers, LazyEraserContainer, LazyFAQ, LazyInvoices, LazyMerchant, LazyMerchantCategories, LazyMerchantEdit, LazyMerchantOpeningHours, LazyNewCustomDomain, LazyOrderProductDetails, LazyOrders, LazyProducts, LazyProductsAdd, LazyProductsEdit, LazyProductsEditImage, LazyProductsExtractions, LazyProductsLinks, LazyProductsProductsModel3D, LazyTransformContainer, LazyWebsite } from '../routes/LazyComponents';
import './RoutesLogin.css';

const SuspenseFallback = () => {
  const portalContainerRef = useRef(null);
  useEffect(() => {
    const loadingSpinner = document.querySelector('#spinner');
    const loadingSpinnerCloned = loadingSpinner.cloneNode(true);
    loadingSpinnerCloned.style.display = 'flex';
    loadingSpinnerCloned.style.minHeight = 'calc(100vh - 100px)';
    portalContainerRef.current.appendChild(loadingSpinnerCloned);
  }, [])
  return (
    <div className='suspenseFallback'>
      <div ref={portalContainerRef} style={{ marginBottom: '150px !important' }}></div>
    </div>)
}

const RoutesLogin = (props) => {
  const dispatch = useDispatch();
  let match = useRouteMatch({
    path: '/products/:id/eraser',
    strict: true,
    sensitive: true,
  });
  let match2 = useRouteMatch({
    path: '/products/:id/transform',
    strict: true,
    sensitive: true,
  });
  const {
    app: { lang, isFetching },
    merchants: { isFetchingMerchants },
    order: { stats, isFetchingOrdersStats },
  } = useSelector((state) => state);
  const isLogin = useSelector(state => state.app.isLogin);
  function hideLoadingSpinner() {
    const loadingSpinner = document.querySelector('#spinner');
    loadingSpinner.style.display = 'none';
  }

  function showLoadingSpinner() {
    const loadingSpinner = document.querySelector('#spinner');
    loadingSpinner.style.display = 'flex';
  }

  const { pathname } = useLocation();

  useEffect(() => {
    const scrollElement = (py) => {
      const element = document.getElementById("pproducts");
      if (element) {
        element.scrollTop = parseInt(py);
      }
    };

    if (pathname === "/products") {
      const savedPosition = sessionStorage.getItem('scrollPosition') || "0";
      const timeoutId = setTimeout(() => scrollElement(savedPosition), 10);
      return () => clearTimeout(timeoutId);
    }
  }, [pathname]);

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // showLoadingSpinner();
    setShowContent(true)

    dispatch(requestUserInfo(docCookies.getItem('token')))
      .then(() => {
        augmentProgress(33);
        augmentProgress(66);
        augmentProgress(100);
        hideLoadingSpinner();
        setShowContent(true)
        dispatch(requestMerchants(null)).then(async (result) => {
          if (result && result.payload) {
            await dispatch(requestMerchantCategories(result.payload.id));

            dispatch(requestOrderStats(result.payload.id));
            dispatch(receivedMerchant(result.payload));
            // Ron To Do -- DELETE WHEN BACKEND FINISH //
            dispatch(requestCategories(null));
            dispatch(requestProducts());
          } else {
            //TODO: mostrar mensaje que merchant no existe.
          }
        });
      })
      .then(() => {
      });
  }, [/* dispatch */]);

  const render = () => {
    // if (
    //   !isFetching &&
    //   !isFetchingMerchants
    // ) {
    return (
      <>
        {isLogin && showContent &&
          <div className="overflow-hidden">
            <AndroidSmartBanner />
            <Menu stats={[]} lang={'es'} />
            <div className="container-fluid">
              <div className="row" style={{ flexWrap: 'nowrap' }}>
                <SideBar stats={stats} lang={lang} />
                <Suspense
                  fallback={<SuspenseFallback />}>
                  <Switch>
                    {/* PRODUCTS */}
                    <Route path="/products/add" component={LazyProductsAdd} />
                    <Route path="/products/:id/edit" component={LazyProductsEdit} />
                    <Route
                      path="/products/:id/edit-image"
                      component={LazyProductsEditImage}
                    />
                    <Route
                      path="/products/:id/extractions"
                      component={LazyProductsExtractions}
                    />
                    <Route
                      path="/products/:id/model3d"
                      component={LazyProductsProductsModel3D}
                    />
                    <Route
                      path="/products/:id/eraser"
                      component={LazyEraserContainer}
                    />
                    <Route
                      path="/products/:id/transform"
                      component={LazyTransformContainer}
                    />
                    <Route path="/products-links" component={LazyProductsLinks} />
                    <Route path="/products" component={LazyProducts} />

                    {/* MERCHANT */}
                    <Route path="/merchant/edit" component={LazyMerchantEdit} />
                    <Route
                      path="/merchant/opening-hours"
                      component={LazyMerchantOpeningHours}
                    />
                    <Route
                      path="/merchant/categories"
                      component={LazyMerchantCategories}
                    />
                    <Route path="/merchant/invoices" component={LazyInvoices} />
                    <Route path="/merchant" component={LazyMerchant} />

                    {/* MIX */}
                    <Route path="/website" component={LazyWebsite} />
                    <Route path="/domain" component={LazyCustomDomain} />
                    <Route path="/storefrontdomain" component={LazyNewCustomDomain} />
                    <Route path="/faq" component={LazyFAQ} />
                    <Route path="/analytics" component={LazyAnalytics} />
                    <Route path="/customers" component={LazyCustomers} />
                    <Route path="/order/detail" component={LazyOrderProductDetails} />
                    <Route path="/orders" component={LazyOrders} />
                    <Route path="/token" component={AuthByToken} />
                    <Route path="/stripe" component={LazyMerchant} />
                    <Route path="/billing" component={LazyBilling} />
                    <Redirect from="*" to="/products" />
                  </Switch>
                </Suspense>
              </div>
            </div>
            {/* <Footer lang={lang} /> */}
          </div>
        }
      </>
    );
    // }
  };
  if (match) {
    return <Route path="/products/:id/eraser" component={LazyEraserContainer} />;
  }
  if (match2) {
    return <Route path="/products/:id/transform" component={LazyTransformContainer} />;
  }
  return render()
};
export default RoutesLogin;
